<script setup lang="ts">
  import type { JourneyTemplateWithExtraOptions } from '@/types/idf-journey-product'
  import type {
    OrganizationStroomFieldConfig,
    OrganizationStroomOption,
  } from '@/types/organization-config'
  import { DropDown } from '@logistiek-zonder-papier/lzp-library'
  import { computed } from 'vue'

  const { fieldConfig } = defineProps<{
    fieldConfig: OrganizationStroomFieldConfig & {
      options: OrganizationStroomOption[]
    }
    error?: string | undefined
  }>()

  const journeyTemplate = defineModel<JourneyTemplateWithExtraOptions>({
    required: true,
  })

  function setOption(item: OrganizationStroomOption) {
    journeyTemplate.value.extraOptions[fieldConfig.key] = item.key
  }

  const extraOption = computed<OrganizationStroomOption | null>({
    get: () => {
      const itemKey = journeyTemplate.value.extraOptions[fieldConfig.key]
      const matched = fieldConfig.options.find(option => option.key === itemKey)

      if (itemKey == null || matched == null) {
        return null
      }

      return {
        key: itemKey,
        label: matched.label,
        selected: false,
      }
    },

    set: (item: OrganizationStroomOption | null) => {
      if (item && 'key' in item) {
        journeyTemplate.value.extraOptions[fieldConfig.key] = item.key
      }
    },
  })
</script>

<template>
  <DropDown
    :data="fieldConfig.options"
    @update:model-value="setOption"
    :model-value="extraOption"
    :label="fieldConfig.fieldLabel ?? '!!!Label not configured!!!'"
    :error="error"
    :data-validation-error="!!error"
    required
  >
    <template #item="{ item }">
      {{ item.label }}
    </template>
  </DropDown>
</template>

<style scoped></style>
